export default __webpack_public_path__ + "static/media/footer-bg.67e95f05.jpg";